import { ErrorMessage } from 'formik';

import { AlluraErrorMessage } from './AlluraErrorMessage';

interface Props {
  fieldName: string;
}

export const AlluraFormikErrorMessage = ({ fieldName }: Props) => {
  return (
    <ErrorMessage
      name={fieldName}
      render={(msg: string) => {
        return <AlluraErrorMessage id={fieldName}>{msg}</AlluraErrorMessage>;
      }}
    />
  );
};
